import classes from './HowPaysWorks.module.css'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { MDBBtn } from 'mdb-react-ui-kit'

import step1 from '../../assets/img/how1.png'
import step2 from '../../assets/img/how2.png'
import step3 from '../../assets/img/how3.png'
import step4 from '../../assets/img/how4.png'

import num1 from '../../assets/img/1step.svg'
import num2 from '../../assets/img/2step.svg'
import num3 from '../../assets/img/3step.svg'
import num4 from '../../assets/img/4step.svg'

import StepCard from './StepCard'

const responsive = {
  wideScreen: {
    breakpoint: { max: 4700, min: 2050 },
    items: 4,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 2050, min: 1750 },
    items: 3,
    partialVisibilityGutter: 80,
    slidesToSlide: 1,
  },
  desktopSmall: {
    breakpoint: { max: 1750, min: 1550 },
    items: 3,
    partialVisibilityGutter: 40,
    slidesToSlide: 1,
  },
  desktopXL: {
    breakpoint: { max: 1550, min: 1200 },
    items: 2,
    partialVisibilityGutter: 130,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 1200, min: 0 },
    items: 2,
    partialVisibilityGutter: 60,
    slidesToSlide: 1,
  },
}

const steps = [
  {
    step: num1,
    image: step1,
    text: '24/7 Online registrieren',
  },
  {
    step: num2,
    image: step2,
    text: 'Einfache Verifizierung',
  },
  {
    step: num3,
    image: step3,
    text: 'Gutscheine erhalten',
  },
  {
    step: num4,
    image: step4,
    text: 'Gutscheincodes 24/7 nutzen',
  },
]

export default function HowPaysWorks() {
  return (
      <div className={`${classes.howPaysWorks} w-100 text-center`}>
        <h2 className='text-center my-lg-5'>Wie funktioniert PAYS</h2>
        <Carousel
          responsive={responsive}
          arrows={true}
          swipeable={true}
          draggable={true}
          keyBoardControl={true}
          customTransition='transform 500ms ease-in-out'
          transitionDuration={500}
          containerClass={classes.carouselContainer}
          partialVisible={true}
          className='py-5 px-5 d-none d-md-flex'
        >
          {steps.map((step, index) => (
            <StepCard
              key={index}
              step={step.step}
              image={step.image}
              text={step.text}
            />
          ))}

        </Carousel>
        <div className='d-block w-100 d-md-none text-center'>
        {steps.map((step, index) => (
          <StepCard
            key={index}
            step={step.step}
            image={step.image}
            text={step.text}
          />
        ))}
        </div>
        <MDBBtn className='btn-pays my-4 my-md-5'>Jetzt kaufen</MDBBtn>
      </div>
  )
}
